import Vue from 'vue'
import Router from 'vue-router'
const home = () => import('@/views/home')
const punish = () => import('@/views/punish')
const punishWeek = () => import('@/views/punish_week')
const list = () => import('@/views/list')
const appeal = () => import('@/views/appeal')
const formDate = () => import('@/views/formDate')
const announcement = () => import('@/views/announcement')


Vue.use(Router)
export default new Router({
  mode: 'history',
  base: '/tools/selfservice/',
  routes: [{
      path: '/',
      redirect: 'home',
      component: home
    }, {
      path: '/home',
      name: 'home',
      component: home
    }, {
      path: '/punish',
      name: 'punish',
      component: punish
    },
    {
      path: '/list',
      name: 'list',
      component: list
    }, {
      path: '/punishWeek',
      name: 'punishWeek',
      component: punishWeek
    }, {
      path: '/formDate',
      name: 'formDate',
      component: formDate
    }, {
      path: '/appeal',
      name: 'appeal',
      component: appeal
    }, {
      path: '/announcement',
      name: 'announcement',
      component: announcement
    },
    // {
    //   path: '/result/:type',
    //   name: 'result',
    //   component: result
    // },
  ]
})
